/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _forEach from 'lodash/forEach'
import _cloneDeep from 'lodash/cloneDeep'
import _find from 'lodash/find'

export const getHoursMin = (sec, t) => {
  sec = Number(sec)
  if (sec > 0 && sec <= 3600) {
    return '1H'
  }
  if (sec > 3600 && sec <= 86400) {
    const min = Math.floor((sec % 3600) / 60)
    return `${Math.floor(sec / 3600)}H${min <= 0 ? '' : `${min}M`}`
  }
  if (sec > 86400) {
    const hour = Math.floor((sec % 86400) / 3600)
    const day = Math.floor(sec / 86400)
    if (day > 1825) {
      return t ? t('永久') : '永久'
    }
    return `${day}D${hour <= 0 ? '' : `${hour}H`}`
  }
  return '0H'
}

export enum PrivateTypeEnum {
  头像框 = 1,
  进场特效 = 2,
  弹幕气泡特效 = 3,
  个人资料特权 = 4,
  声纹特权 = 5,
  上麦特权 = 6,
  称号牌 = 7,
  进场通知 = 8,
  多彩气泡 = 9,
  个人页动效 = 10,
  聊天背景 = 11,
  置顶消息皮肤 = 12,
  碎片 = 1000,
  主页皮肤 = 13,
}

export enum WearStatusEnum {
  未穿戴 = 0,
  已穿戴 = 1,
}

const formatRes = (data, curObj) => {
  const obj = {}
  for (let i = 1; i <= 13; i++) {
    obj[i] = {
      total: 0,
      list: [],
      curSelected: {},
    }
  }
  obj[PrivateTypeEnum.碎片] = {
    total: 0,
    list: [],
    curSelected: {},
  }
  _forEach(data?.list, (item) => {
    const curSelected =
      _find(item.list, (li) => li.wear_status === WearStatusEnum.已穿戴) || {}
    obj[item.type] = {
      total: item.total,
      list: item.list,
      curSelected: curObj[item.type]?.curSelected || curSelected,
    }
  })
  return {
    user: {
      avatar: data?.avatar,
      name: data?.nick_name,
    },
    obj,
    enter_room_msg_map: data.enter_room_msg_map,
  }
}

export const get_outfit_homepage = createAsyncThunk(
  'PersonalDressUp/get_outfit_homepage',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/get_outfit_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_privileges_by_mid = createAsyncThunk(
  'PersonalDressUp/get_privileges_by_mid',
  async (p: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/privilege/get_privileges_by_mid',
      {
        mid: deviceinfo.h_m,
      },
      {store, xcErrorToast: true}
    )
    return formatRes(resp.data.data, store.getState().PersonalDressUp.obj)
  }
)
export const query_privilege_effect = createAsyncThunk(
  'PersonalDressUp/query_privilege_effect',
  async (params: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/privilege/query_privilege_effect',
      {
        mid: deviceinfo.h_m,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const update_wear_status = createAsyncThunk(
  'PersonalDressUp/update_wear_status',
  async (p: any, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/privilege/update_wear_status',
      {
        mid: deviceinfo.h_m,
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

const initialState: {
  base: any
  user: any
  obj: any
  curPrivateType: PrivateTypeEnum
  enter_room_msg_map: any
} = {
  base: {
    showGuide1: false,
    showGuide2: false,
    showGuide3: false,
  },
  user: {},
  obj: {},
  curPrivateType: PrivateTypeEnum.碎片,
  enter_room_msg_map: {},
}

export const PersonalDressUpSlice = createSlice({
  name: 'PersonalDressUp',
  initialState,
  reducers: {
    updateShowGuide: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        base: {
          ...state.base,
          ...action.payload,
        },
      })
    },
    updatePrivateType: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        curPrivateType: action.payload,
      })
    },
    updateCurSelected: (state, action: PayloadAction<any>) => {
      const obj = _cloneDeep(state.obj)
      obj[state.curPrivateType].curSelected = action.payload
      Object.assign(state, {
        obj,
      })
    },
    updateList: (state, action: PayloadAction<any>) => {
      const obj = _cloneDeep(state.obj)
      obj[state.curPrivateType]?.list?.forEach((item) => {
        item.wear_status = WearStatusEnum.未穿戴
      })
      const idx = obj[state.curPrivateType]?.list?.findIndex(
        (item) => item.privilege_id === action.payload?.privilege_id
      )
      obj[state.curPrivateType].list[idx] = action.payload
      Object.assign(state, {
        obj,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_privileges_by_mid.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})

export const usePersonalDressUp = () =>
  useSelector((store) => store.PersonalDressUp)

export default PersonalDressUpSlice.reducer
export const PersonalDressUpActions = PersonalDressUpSlice.actions
